import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const CustomTextFieldStyle = makeStyles()((theme: Theme) => ({
  passwordVisibility: {
    cursor: 'pointer',
    height: '32px',
    marginTop: '-16px',
    '& .MuiTypography-root': {
      position: 'relative',
      top: '3px',
      left: '-1px',
      [theme.breakpoints.between(0, 600)]: {
        left: '-10px',
      },
    },
    '& .MuiIconButton-root': {
      padding: theme.spacing(1, 1.5),
    },
  },
  label: {
    width: '39.5px',
    display: 'inline-block',
    color: '#4F5A65',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 'bold',
    fontFamily: 'Acronym-Regular',
    marginBottom: '10px',
    [theme.breakpoints.between(0, 600)]: {
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0.07em',
    },
  },
}))

export default CustomTextFieldStyle
